import { advancedFlowSchema } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import * as z from "zod";

export const getAdvancedFlowById = {
  name: "getAdvancedFlowById" as const,
  input: z.object({ flowId: z.string() }),
  output: z.object({ advancedFlow: advancedFlowSchema }),
};
